import { all, call, put, takeLatest } from 'redux-saga/effects';
import { handleApiErrors } from '../../lib/api-errors';
import {
  CATEGORY_REQUESTING,
  CONFIG_REQUESTING,
  SAVE_CATEGORY_REQUESTING,
} from './constants';

import {
  categoryRequestError,
  categoryRequestSuccess,
  configRequestError,
  configRequestSuccess,
} from './actions';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => {
      throw error;
    });
}

function configRequestApi() {
  const url =
    process.env.NODE_ENV !== 'production'
      ? `http://banggia.tvs.vn/server.cfg`
      : `/server.cfg`;
  // const url = `https://banggia.tvs.vn/server.cfg`
  const request = fetch(url);

  return handleRequest(request);
}

function categoryRequestApi(data) {
  const url = `${apiUrl}/CoreServlet.pt`;
  const request = fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });

  return handleRequest(request);
}

function* configRequestFlow() {
  try {
    console.log('configRequestFlow');
    const data = yield call(configRequestApi);
    // console.log('configRequestFlow', data)
    yield put(configRequestSuccess(data));
  } catch (error) {
    // console.log('configRequestFlow', error)
    yield put(configRequestError(error));
  }
}

function* categoryRequestFlow(action) {
  try {
    const category = yield call(categoryRequestApi, action.data);
    // console.log(category)
    yield put(categoryRequestSuccess(category.data));
  } catch (error) {
    yield put(categoryRequestError(error));
  }
}

function* saveCategoryRequestFlow(action) {
  try {
    const category = yield call(categoryRequestApi, action.data);
    console.log(category);
    // yield put(categoryRequestSuccess(category.data));
  } catch (error) {
    // yield put(categoryRequestError(error));
  }
}

function* clientWatcher() {
  yield all([
    takeLatest(CONFIG_REQUESTING, configRequestFlow),
    takeLatest(CATEGORY_REQUESTING, categoryRequestFlow),
    takeLatest(SAVE_CATEGORY_REQUESTING, saveCategoryRequestFlow),
  ]);
}

export default clientWatcher;
